import React from 'react'
import { pdfIcon } from '../../assets/Images'
import { truncateTitle } from '../../middleware/truncateTitle'
import { useTranslation } from 'react-i18next'
import { media } from '../../server'
import { Button } from '../layout'
import { FaDownload } from "./icons"
import {Link} from "react-router-dom"
function PdfViewer({fileName ,fileImage , fileUrl,pdfSize ,pdfImageSize}) {
    const { t } = useTranslation()
    const handleDownload = (e) => {
        e.preventDefault(); // يمنع إجراء submit إذا كان داخل نموذج
        window.open(  fileUrl, '_blank'); // يفتح الملف في نافذة/تبويب جديد
    };

  return (
    <div className={`${pdfSize ? pdfSize : "h-[200px] max-w-[175px]"}  relative bg-color-1 p-2 rounded-md flex flex-col`}>
        <div className={`bg-back-primery w-full h-[150px] ${pdfImageSize ? pdfImageSize : "h-[150px]"} rounded-md`}> 
        {
            fileImage ? (
                <img src={fileImage} alt="pdf" className='w-full h-full object-cover rounded-md' />
            ) : (
                <div className="w-full h-full flex items-center justify-center">
                <p className="text-gray-500 text-sm font-kufi">{t("No Image Available")}</p>
                </div>
            )
        }
        </div>
<div className="flex h-[50px] overflow-hidden flex-row items-start pt-2 justify-start">
    <img src={pdfIcon} alt="pdfIcon" className='h-[40px]  object-contain' />
    <div className="pt-3 px-2">
    <h1 className='text-[14px] font-kufi  font-bold text-tcolor-1 text-wrap'>{truncateTitle(fileName ,2)}</h1>
    </div>
       
    
</div>
{fileUrl &&

      <button onClick={handleDownload} className= "font-kufi text-sm gap-1 pt-2 flex flex-row justify-center items-center  text-tcolor-1 text-simeBold" >  
      <FaDownload /> {t("Download")}
      </button>
   
    }
    </div>
  )
}

export default PdfViewer